module.exports = __webpack_public_path__ + "img/ic_point.616031c9.svg";